import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { SubUrlsEnum } from '../enums/sub-urls.enum';
import {
    ICredit,
    ICreditDTOOut,
    IDebit,
    IDebitDTOOut,
    ILoadClassInterfaceDtoOut,
    ITransferDTOOut,
    IUnload,
    IUnloadClassInterfaceDtoOut,
    IUnloadDTOOut,
    IWalletV2,
} from '../interfaces/wallet.interface';
import { IWalletInV2, IWalletsIn } from './../interfaces/wallet.interface';
import { MappersService } from './mappers.service';
import { WalletMapper } from './mappers/wallet.mapper';

@Injectable({
    providedIn: 'root',
})
export class WalletService {
    constructor(private http: HttpClient, private mapperService: MappersService, private walletMapper: WalletMapper) {}

    public getMyWalletsV2(studentId?: number): Observable<IWalletV2[]> {
        let params: HttpParams = new HttpParams();
        if (studentId) {
            params = params.set('viewing_student_id', studentId);
        }
        return this.http
            .get<IWalletsIn>(environment.wasoApi + SubUrlsEnum.WALLETS_TRANSACTIONS, { params: studentId ? params : null })
            .pipe(map((wallet: IWalletsIn) => wallet.wallets.map((w: IWalletInV2) => this.walletMapper.fromIWalletDTOToWalletV2(w))));
    }

    public getWalletByUserIdV2(parentId: number): Observable<IWalletV2> {
        const url: string = environment.wasoApi + SubUrlsEnum.PARENTS + '/' + parentId + '/' + SubUrlsEnum.WALLET;
        return this.http.get<IWalletV2>(url);
    }

    public creditWallet(credit: ICreditDTOOut): Observable<ICredit> {
        return this.http.post<ICredit>(environment.wasoApi + SubUrlsEnum.CREDITS, credit);
    }

    public debitWallet(debit: IDebitDTOOut): Observable<IDebit> {
        return this.http.post<IDebit>(environment.wasoApi + SubUrlsEnum.DEBITS, debit);
    }

    public unloadWallet(unload: IUnloadDTOOut, parentId: number): Observable<IUnload> {
        const url: string = environment.wasoApi + SubUrlsEnum.UNLOAD_WALLET.replace('{{parent_id}}', parentId?.toString());
        return this.http.post<IUnload>(url, unload);
    }

    public transferMoney(transfer: ITransferDTOOut, userToId: number): any {
        // todo modify 'any' with response type from back [TRANSFER]
        let params: HttpParams = new HttpParams();
        if (userToId) {
            params = params.set('user_id', userToId);
        }
        return this.http.post(environment.wasoApi + SubUrlsEnum.TRANSFER_MONEY, transfer, { params });
    }

    public loadClassWallet(params: ILoadClassInterfaceDtoOut): Observable<any> {
        return this.http.post<any>(environment.wasoApi + SubUrlsEnum.LOAD_CLASS_WALLET, params);
    }

    public unloadClassWallet(params: IUnloadClassInterfaceDtoOut): Observable<void> {
        return this.http.post<void>(environment.wasoApi + SubUrlsEnum.UNLOAD_CLASS_WALLET, params);
    }

    public cancelPaymentItems(id: number): Observable<void> {
        const options: { headers: HttpHeaders; body: any } = {
            headers: new HttpHeaders(),
            body: {
                payment_item_ids: [id],
            },
        };
        return this.http.delete<void>(environment.wasoApi + SubUrlsEnum.CANCEL_PAYMENT_ITEM, options);
    }
}
